import React, { PureComponent } from 'react';

import {
    View,
    StyleSheet
} from 'react-native';

import {
    JDDialog,
    JDTouchable,
    JDImage
} from '@jdreact/jdreact-core-lib';

import { pt, tip } from '../../common/utils';
import { get, signPost } from '../../common/fetch';
import sgmReport from '../../common/sgmUtil';

class LigntLicence extends PureComponent {
    state = { fileUrl: '' }

    static defaultProps = {
        dialogShow: false,
        venderId: '',
        closeLicenceDialog: () => { }
    }

    render() {
        const { fileUrl } = this.state;
        const { dialogShow } = this.props;

        return (
            <JDDialog dialogStyle={ st.dialog }
                show={ dialogShow }
                onClose={ () => this._closeDialog() }>
                <View style={ st.wrap }>
                    <JDTouchable onPress={ () => this._closeDialog() }>
                        <View style={ { flexDirection: 'row', justifyContent: 'flex-end', marginBottom: pt(20) } }>
                            <JDImage style={ st.close } source={ img.close } />
                        </View>
                    </JDTouchable>
                    <JDTouchable onPress={ () => this._closeDialog() }>
                        {
                            fileUrl
                                ? (
                                    <JDImage style={ { width: pt(338) } } source={ { uri: fileUrl } } />
                                )
                                : null
                        }

                    </JDTouchable>
                </View>
            </JDDialog>
        );
    }

    componentWillMount() {
        this._getCompanyMessage();
    }

    _closeDialog = () => {
        this.props.closeLicenceDialog();
    }

    _getCompanyMessage = () => {
        const { venderId } = this.props;
        signPost('movie.getCompanyMessage', {venderId}, 'get').then(res => {
            if (res.code === 0) {
                this.setState({
                    fileUrl: res.data
                });            
            }
        })

        if(!venderId){
            sgmReport('1001', {function_id: 'movie.getCompanyMessage',message:'缺少参数venderId'}, 3)
        }
        
    }
}

const img = {
    close: require('../../img/close_white.png')
};
const st = StyleSheet.create({
    dialog: {
        width: '89.3%',
        backgroundColor: 'transparent',
        borderWidth: 0
    },
    close: {
        height: pt(27),
        width: pt(27)
    },
    wrap: {
        height: '100%',
        justifyContent: 'center',
        alignItems: 'flex-end',
        width: '100%'
    }
});

export default LigntLicence;
